// import { Component } from 'react';
// import { connect } from 'react-redux';
// import { logoutUser } from '../../Actions/authActions';
// import { RouteComponentProps } from 'react-router-dom';

// type LogoutProps = {
//   logoutUser: () => void;
// } & RouteComponentProps

// class Logout extends Component<LogoutProps, {}> {
//   componentDidMount() {
//     this.props.logoutUser();
//     this.props.history.push('/');
//   }
//   render() {
//     return (''
//     )
//   }
// }

// export default connect(null, { logoutUser })(Logout);

import React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { logoutUser } from '../../Actions/authActions';
import { useHistory } from 'react-router';

type LogoutProps = {
  logoutUser: () => void;
}

const Logout = ({ logoutUser }: LogoutProps) => {
  const history = useHistory();
  useEffect(() => {
    logoutUser();
    history.push('/');
  }, [logoutUser, history]);

  return (<></>);
}

export default connect(null, { logoutUser })(Logout);
